import React from "react";
import { Button, EmptyState } from "@procore/core-react";
import { useI18nContext } from "@procore/core-react";

interface ErrorComponentProps {
   error?: Error;
}

export const ErrorComponent: React.FC<ErrorComponentProps> = () => {
   const I18n = useI18nContext();
   return (
      <EmptyState>
         <EmptyState.NoResults />
         <EmptyState.Title>
            {I18n.t("views.company.workforce_planning.errorBoundary.title")}
         </EmptyState.Title>
         <EmptyState.Description>
            {I18n.t("views.company.workforce_planning.errorBoundary.description")}
         </EmptyState.Description>
         <EmptyState.Actions>
            <Button
               onClick={() => {
                  window.location.reload();
               }}
            >
               {I18n.t("views.company.workforce_planning.errorBoundary.try_again")}
            </Button>
         </EmptyState.Actions>
      </EmptyState>
   );
};
